/**
 * Build the name shown on a card: the species name plus its form, if any.
 *
 * Tier list names only carry "(Shadow)" / "(Mega X)", never the regional or
 * alternate form, so without this Thundurus Incarnate and Thundurus Therian both
 * render as a bare "Thundurus" and read as duplicates.
 *
 *   ("Thundurus", "Therian")        -> "Thundurus (Therian)"
 *   ("Thundurus (Shadow)", "Incarnate") -> "Thundurus (Shadow, Incarnate)"
 *   ("Charizard (Mega X)", "X")     -> "Charizard (Mega X)"   (already named)
 *   ("Venusaur (Mega)", "Normal")   -> "Venusaur (Mega)"
 */
export function formatPokemonDisplayName(name, form) {
  if (!name) return '';
  if (!form || form === 'Normal') return name;

  const label = formatFormLabel(form);
  const match = name.match(/^(.*?)\s*\(([^)]+)\)\s*$/);
  if (!match) return `${name} (${label})`;

  const [, base, existing] = match;
  // "(Mega X)" already names the form; appending "(X)" would just repeat it.
  if (/^Mega/.test(existing)) return name;
  return `${base} (${existing}, ${label})`;
}

export function formatFormLabel(form) {
  if (!form) return '';
  if (form === 'Normal') return 'Normal';

  const withSpaces = String(form).replace(/_/g, ' ');

  return withSpaces
    .split(/\s+/)
    .filter(Boolean)
    .map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ');
}

